// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Malawi from '../_raw/flag/icon_flag_malawi.png';

export default () => <img src={Malawi} alt="Malawi" />;
